import { render, staticRenderFns } from "./TextareaSelector.vue?vue&type=template&id=0605a66a&"
import script from "./TextareaSelector.vue?vue&type=script&lang=babel&"
export * from "./TextareaSelector.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports